// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonSecurity = {
  normal: "正常",
  mustChangePassword: "パスワード変更必須",
  locked: "ロック済み",
  unlocked: "未ロック",
  failedLoginAttempts: "{count} 回失敗",
  superuser: "スーパー管理者",
} as const;
